import { ApolloLink } from '@apollo/client'

export const cleanTypeNameLink = new ApolloLink((operation, forward) => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,sonarjs/different-types-comparison
    if (operation.variables !== null) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      const newVariables = JSON.parse(JSON.stringify(operation.variables), (key, value: unknown) =>
        key === '__typename' ? undefined : value,
      ) as Record<string, unknown>
      // eslint-disable-next-line no-param-reassign
      operation.variables = newVariables
    }
  } catch {
    // nothing
  }

  return forward(operation).map((data) => data)
})
